import React, { useEffect, useState } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
function RedirectCheckoutPlugins() {
  const [OptionData, SetOptionData] = useState([]);
  const [TabCheck, SetTabCheck] = useState(false);
  function onClickCangeTab() {
    SetTabCheck(!TabCheck);
  }
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_layout1">
              <h1>Redirect checkout & plugins</h1>
              <hr />
              <h2 class="mt-60">Server side integration</h2>
              <p>
                Safexpay provide various integration platforms to integrate
                payments in your website. Our payment gateway can be integrated
                using almost all major programming languages{" "}
                <b>viz ; JAVA , PHP, Python , .NET & many more</b>. Have a look
                at the animated video below to understand payment collection
                through Safexpay.
              </p>
              {/* <video width="500" controls="" autoplay="">
                  <source src="assets/images/pg-images/integration.mp4" type="video/mp4"/>
                  Your browser does not support HTML video.
               </video> */}
              <br />
              <br />
              <h5 class="mt-30">
                <u>Supported programming platforms.</u>
              </h5>
              <br />
              <br />
              <div class="row">
                <div class="col-md-4">
                  <div class="bx-sh-bor">
                    <center>
                      <img
                        class="img-fluid"
                        src="assets/images/pg-images/node.png"
                      />
                    </center>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="bx-sh-bor">
                    <center>
                      <img
                        class="img-fluid img-width"
                        src="assets/images/pg-images/download.png"
                      />
                    </center>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="bx-sh-bor">
                    <center>
                      <img
                        class="img-fluid img-width"
                        src="assets/images/pg-images/download (1).png"
                      />
                    </center>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div class="row">
                <div class="col-md-4">
                  <div class="bx-sh-bor">
                    <center>
                      <img
                        class="img-fluid img-width"
                        src="assets/images/pg-images/NET_Core.1d1f05e0.png"
                      />
                    </center>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="bx-sh-bor">
                    <center>
                      <img
                        class="img-fluid"
                        src="assets/images/pg-images/download (2).png"
                      />
                    </center>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="bx-sh-bor">
                    <center>
                      <img
                        class="img-fluid img-width"
                        src="assets/images/pg-images/Python.f0c9d647.png"
                      />
                    </center>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div class="row">
                <div class="col-md-4">
                  <div class="bx-sh-bor">
                    <center>
                      <img
                        class="img-fluid"
                        src="assets/images/pg-images/PHP.18c21e1a.png"
                      />
                    </center>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <p class="mb-0">
                To download our Technical integration guide{" "}
                <a
                  href="assets/pdf/Integration document_V-1.4.2.2.pdf"
                  target="_blank"
                >
                  <span className="col-orange">
                    <i>Click here</i>
                  </span>
                </a>
                .
              </p>
              <div class="divider"></div>
            </section>
            <section id="idocs_header1">
              <h2 class="mt-60">E-Commerce Plugins</h2>
              <p>
                SafexPay offers a good set of trending payment plugins for
                ecommerce platforms to collect online payments from the end
                customers on your web site by enabling SafexPay Payment Gateway.
                <br />
                It facilitates the payment collection for your online business
                without any need for developement at merchant side.
              </p>
              <p>
                <b>Plugins:</b> To add the SafexPay Payment Gateway on your
                eCommerce website and accept payment from your customers using
                UPI, Credit/Debit Cards, Netbanking etc. You can simply
                integrate a plugin that suits your ecommerce website.
                <br />
                SafexPay payment plugins that are available for all major
                e-commerce platforms. Below are the list of supported plugins.
              </p>
              <p>
                To start the plugin integration, click on the desired plugin and
                download the same. Refer the video for installing the plugin.
                <br />
                For any support kindly connect us on our Integrations support
                team e-mail address
                <a href="mailto:care@safexpay.ae">
                  {" "}
                  <span className="col-orange">
                    <i>care@safexpay.ae</i>
                  </span>
                </a>
              </p>
              <div class="row">
                {/* <div class="col-md-4">
                  <div class="bx-sh-bor1">
                    <div class="fl">
                      <img
                        class="img-fluid img-width1"
                        src="assets/images/pg-images/magento.0475372d.svg"
                      />
                    </div>
                    <div class="fr lh-60">
                      <label>
                        <b>Magento</b>
                      </label>
                    </div>
                  </div>
                </div> */}
                <div class="col-md-4">
                  <div class="bx-sh-bor1">
                    <div class="fl">
                      <img
                        class="img-fluid img-width1"
                        src="assets/images/pg-images/opencart.5c3d5181.svg"
                      />
                    </div>
                    <div class="fr lh-60">
                      <label>
                        <b>Opencart</b>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="bx-sh-bor1">
                    <div class="fl">
                      <img
                        class="img-fluid img-width1"
                        src="assets/images/pg-images/download (3).png"
                      />
                    </div>
                    <div class="fr lh-60">
                      <label>
                        <b>Prestashop</b>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div class="row">
                {/* <div class="col-md-4">
                     <div class="bx-sh-bor1">
                        <div  class="fl">
                           <img class="img-fluid img-width1" src="assets/images/pg-images/nopcommerce.809095e5.png" />
                        </div>
                        <div class="fr lh-60">
                           <label><b>Nopcommerce</b></label>
                        </div>
                     </div>
                  </div> */}
                {/* <div class="col-md-4">
                     <div class="bx-sh-bor1">
                        <div class="fl">
                           <img class="img-fluid img-width1" src="assets/images/pg-images/virtuemart.b70894fc.png" />
                        </div>
                        <div class="fr lh-60">
                           <label><b>VirtueMart v.1.1</b></label>
                        </div>
                     </div>
                  </div> */}
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="bx-sh-bor1">
                    <div class="fl">
                      <img
                        class="img-fluid img-width1"
                        src="assets/images/pg-images/download (7).png"
                      />
                    </div>
                    <div class="fr lh-60">
                      <label>
                        <b>Woocommerce</b>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="bx-sh-bor1">
                    <div class="fl">
                      <img
                        class="img-fluid img-width2"
                        src="assets/images/pg-images/Shopify_logo.png"
                      />
                    </div>
                    <div class="fr lh-60">
                      <label>
                        <b>Shopify</b>
                      </label>
                    </div>
                  </div>
                </div>
                {/* <div class="col-md-4">
                     <div class="bx-sh-bor1">
                        <div  class="fl">
                           <img class="img-fluid img-width1" src="assets/images/pg-images/download (4).png" />
                        </div>
                        <div class="fr lh-60">
                           <label><b>WHMCS</b></label>
                        </div>
                     </div>
                  </div> */}
                {/* <div class="col-md-4">
                     <div class="bx-sh-bor1">
                        <div class="fl">
                           <img class="img-fluid img-width1" src="assets/images/pg-images/drupal_commerce.f7784176.png" />
                        </div>
                        <div class="fr lh-60">
                           <label><b>Drupal</b></label>
                        </div>
                     </div>
                  </div> */}
              </div>
              <br />
              <br />
              <div class="row">
                {/* <div class="col-md-4">
                     <div class="bx-sh-bor1">
                        <div  class="fl">
                           <img class="img-fluid img-width1" src="assets/images/pg-images/download (5).png" />
                        </div>
                        <div class="fr lh-60">
                           <label><b>Codeigniter</b></label>
                        </div>
                     </div>
                  </div> */}
              {/* <div class="col-md-4">
                     <div class="bx-sh-bor1">
                        <div  class="fl">
                           <img class="img-fluid img-width1" src="assets/images/pg-images/download (6).png" />
                        </div>
                        <div class="fr lh-60">
                           <label><b>Laravel</b></label>
                        </div>
                     </div>
                  </div> */}
                <p className="mt-30 fr">....many more to come..!!!</p>
              </div>

              <div class="divider"></div>
              <h2 class="mt-30">Shopify</h2>
              <div class="row">
                <div class="col-md-4">
                  <div class="">
                    <div class="fl">
                      <img
                        class="img-fluid img-width2"
                        src="assets/images/pg-images/Shopify_logo.png"
                      />
                    </div>
                    <div class="fr lh-60">
                      <label>
                        <b>Shopify</b>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <ul>
                <li>
                  <b>Step 1:</b> Click on the link below:{" "}
                  <a href="https://apps.shopify.com/safexpay">Shopify Link</a>
                </li>
                <li>
                  <b>Step 2:</b> Install the safexpay app.
                </li>
                <li>
                  <b>Step 3:</b> Configure the required details on the same.
                </li>
              </ul>

              <br></br>
              <a
                href="https://apps.shopify.com/safexpay"
                class="btn btn-primary mt-20"
                target="_blank"
              >
                Go to shopify
              </a>

              <div className="woocom-div">
                <div class="divider"></div>
                <h2>Woocommerce Plugin</h2>
                <div class="row">
                  <div class="col-md-4">
                    <div class="">
                      <div class="fl">
                        <img
                          class="img-fluid img-width1"
                          src="assets/images/pg-images/download (7).png"
                        />
                      </div>
                      <div class="fr lh-60">
                        <label>
                          <b>Woocommerce</b>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <ul>
                  <li>
                    <b>Step 1:</b> Go to wp-admin panel.
                  </li>
                  <li>
                    <b>Step 2:</b> Click on Plugins.
                  </li>
                  <li>
                    <b>Step 3:</b>After Plugins go to Add New plugin.
                  </li>
                  <li>
                    <b>Step 4:</b> Click on the Upload Plugin and add the
                    Safexpay Zip Plugin.
                  </li>
                  <li>
                    <b>Step 5:</b> After uploading the Plugin Install the same
                    by clicking on the Install Now button.
                  </li>
                  <li>
                    <b>Step 6:</b> Once the installation part is done click on
                    Activate Plugin.
                  </li>
                  <li>
                    <b>Step 7:</b> After activation of the Safexpay Plugin it
                    will be visible under the Installed Plugins Section.
                  </li>
                  <li>
                    <b>Step 8:</b> Now go to WooCommerce after that click on
                    Settings.
                  </li>
                  <li>
                    <b>Step 9:</b> Go to General select country / State as
                    United Arab Emirates & currency as United Arab Emirates
                    dirham (د.إ).
                  </li>
                  <li>
                    <b>Step 10:</b> Now save the changes by clicking on the
                    button below.
                  </li>
                  <li>
                    <b>Step 11:</b> Go to Payments on the safexpay toggle button
                    after that click on Manage.
                  </li>
                  <li>
                    <b>Step 12:</b> Fill the required details and save the
                    changes.
                  </li>
                  <li>
                    <b>Step 13:</b> Now your safexpay plugin is ready to go.
                  </li>
                </ul>

                <br />
                <br />
                <video width="500" controls="" autoplay="">
                  <source
                    src="assets/images/pg-images/woocommerce.webm"
                    type="video/mp4"
                  />
                  Your browser does not support HTML video.
                </video>
                <br></br>
                <a
                  download
                  href="https://test.safexpay.ae/plugins/Woocommercejs.zip"
                  class="btn btn-primary mt-20"
                  //  target="_blank"
                >
                  Download Plugin
                </a>
              </div>

              {/* <div className="magento-div">
                <div class="divider"></div>
                <h2 className="mt-50">Magento</h2>
                <div class="row">
                  <div class="col-md-4">
                    <div class="">
                      <div class="fl">
                        <img
                          class="img-fluid img-width1"
                          src="assets/images/pg-images/magento.0475372d.svg"
                        />
                      </div>
                      <div class="fr lh-60">
                        <label>
                          <b>Magento</b>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <h5 class="mt-30">Installation Steps (Via FTP)</h5>
                <ol>
                  <li>
                    Extract the zip file of Magento Driver/plugin to your local
                    disk location, let’s call it ‘SOURCE’. You will get one
                    ‘app’ and another ‘doc’ folder where in this integration doc
                    resides.
                  </li>
                  <li>
                    Open your FTP tool e.g. FileZilla, WSFTP, CuteFtp, etc. and
                    in source file side point to your ‘SOURCE’ location.
                  </li>
                  <li>
                    In destination side, connect to your remote host where
                    magento is installed and locate your magento root folder
                    where ‘app’ folder is present.
                  </li>
                  <li>
                    Just upload ‘app’ folder from ‘SOURCE’ to your remote
                    magento root.
                  </li>
                  <li>
                    Follow the configuration section to configure the module in
                    Magento Admin panel.
                  </li>
                </ol>
                <h5>Installation Steps (Via Local PC)</h5>
                <ol>
                  <li>Extract the zip file of Magento Driver/plugin.</li>
                  <li>
                    In the extracted files, navigate to app/code/community. Let
                    us call this
                  </li>
                  <li>
                    Open a new window and navigate to the directory from where
                    your apache server serves your magento files. Let us call
                    this
                  </li>
                  <li>
                    Navigate to directory app/code/community in . The community
                    directory can be named local on a few systems.
                  </li>
                  <li>
                    Copy the Safexpay Directory from Driver Path and paste in
                    /app/code/community/.
                  </li>
                  <li>
                    Now again go to the folder where you extracted the Magento
                    driver/plugin.
                  </li>
                  <li>Navigate to app/etc/modules/. Let us call this .</li>
                  <li>
                    Open a New window and navigate to app/etc/modules in .
                  </li>
                  <li>
                    Copy the file Safexpay_Moto.xml from in /app/etc/modules/.
                  </li>
                  <li>
                    Follow the configuration section to configure the module in
                    Magento Admin panel.
                  </li>
                </ol>
                <h5>Configuring Plugin in Admin Panel</h5>
                <ol>
                  <li>Open the admin console on Magento.</li>
                  <li>
                    Login and Navigate to System-{">"}Configuration-{">"}Payment
                    Methods.You should be able to see Safexpay Payment Module in
                    your Payment Methods.If not, please go to System-{">"}Cache
                    Management Now click on Flush Magento Cache then Flush Cache
                    Storage.Navigate back to System-{">"}Configuration-{">"}
                    Payment Methods Safexpay Payment Module should be visible
                    now.
                  </li>
                  <li>
                    After you have setup information in step 3, click on Save
                    Config and you can have your customers make payment via the
                    Safexpay Payment gateway.
                  </li>
                  <li>
                    While making payment Safexpay will appear as a payment
                    option for the Customer as shown below.
                  </li>
                </ol>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  // download

                  href="#"
                  class="btn btn-primary mb-20"
                  //  target="_blank"
                >
                  Download Plugin
                </a>
              </div> */}

              <div class="divider"></div>
              <h2 class="mt-30">Opencart</h2>
              <div class="row">
                <div class="col-md-4">
                  <div class="">
                    <div class="fl">
                      <img
                        class="img-fluid img-width1"
                        src="assets/images/pg-images/opencart.5c3d5181.svg"
                      />
                    </div>
                    <div class="fr lh-60">
                      <label>
                        <b>Opencart</b>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <ul>
                <li>
                  <b>Step 1:</b> Download the Plugin.
                </li>
                <li>
                  <b>Step 2:</b> Goto Extensions-{">"}Installer and upload the
                  downloaded safexpay zip.
                </li>
                <li>
                  <b>Step 3:</b> Goto Extensions-{">"}Extensions-{">"}Select
                  Payments from the drop down list enable the safexpay payment
                  option and press edit option which will allow you to pass the
                  details that are provided by safexpay.
                </li>
                <li>
                  <b>Step 4:</b> Just save the changes and you are ready to use
                  SafexPay Payment plugin.
                </li>
              </ul>
              <video width="500" controls="" autoplay="">
                <source
                  src="assets/images/pg-images/Opencart.webm"
                  type="video/mp4"
                />
                Your browser does not support HTML video.
              </video>

              <br></br>
              <a
                download
                href="https://test.safexpay.ae/plugins/Opencart.zip"
                class="btn btn-primary mt-20"
                //  target="_blank"
              >
                Download Plugin
              </a>

              {/* <div class="divider"></div> */}

              {/* <div className="">

             
               <h2>Zencart11</h2>
               <div class="row">
                  <div class="col-md-4">
                     <div class="">
                        <div class="fl">
                           <img class="img-fluid img-width1" src="assets/images/pg-images/zencart.5f2669c5.png" />
                        </div>
                        <div class="fr lh-60">
                           <label><b>Zencart</b></label>
                        </div>
                     </div>
                  </div>
               </div>
               <p className='mt-30'>
                  It allows you to use Safexpay payment gateway with the Zencart shopping cart. This is the Safexpay payment gateway module for Zencart. Allows you to use Safexpay payment gateway with the Zencart plugin. It uses the Safexpay payment url for payment so that you don't have to install an SSL certificate on your site.
               </p>
               <h5>Installation</h5>
               <ol>
                  <li>Ensure you have Zencart v1.5.7 installed.</li>
                  <li>Unzip and upload contents of the includes to your /zencart install directory/includes/ directory.</li>
                  <li>Login to your zen cart admin & go to "Modules", then "Payment" & select Safexpay from the list and click on install.</li>
               </ol>
               <h5>Configuration</h5>
               <ol>
                  <li>Login to your zen cart admin & go to "Modules", then "Payment" & select Safexpay from the list and click on Edit.</li>
                  <li>Enter your Merchant id ,Merchant Key,Transaction Type and Url and save the configuration.</li>
               </ol>
               <a href="https://paygateindiapvt-my.sharepoint.com/personal/marketing_safexpay_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Fmarketing%5Fsafexpay%5Fcom%2FDocuments%2FDeveloper%20Doc%20Plugins%2FZencart%2FZencart%2DSafexpay%5Fchecksum%2Ezip&parent=%2Fpersonal%2Fmarketing%5Fsafexpay%5Fcom%2FDocuments%2FDeveloper%20Doc%20Plugins%2FZencart&ga=1" class="btn btn-primary" target="_blank">Download Plugin11</a>
               </div> */}

              <div class="divider"></div>
              <h2>Prestashop</h2>
              <div class="row">
                <div class="col-md-4">
                  <div class="">
                    <div class="fl">
                      <img
                        class="img-fluid img-width1"
                        src="assets/images/pg-images/download (3).png"
                      />
                    </div>
                    <div class="fr lh-60">
                      <label>
                        <b>Prestashop</b>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <p className="mt-30">
                Following are the steps to upload and configure Safexpay payment
                module under Prestashop v1.6.0.11.
              </p>
              <ol>
                <li>
                  Unzip the Safexpay_Prestashop.zip and upload the directory
                  named ‘Safexpay to your server at following path - / modules /
                </li>
                <li>
                  Login to Prestashop admin panel and goto ‘Modules’ menu.
                  Locate the safex payment module as below. Click on ‘Install’
                  at the right of the module.
                </li>
                <li>
                  After installation is successfully done. Click on ‘Configure’
                  link inside the module box. The following page will appear.
                </li>
                <li>
                  Fill-up appropriate information as received from Safexpay.
                  Finally click on ‘Update Settings’.
                </li>
                <li>
                  Logout and go to shop page to try the module via checkout. If
                  everything is installed and configure correctly, you will be
                  able to checkout via Safexpay payment page.
                </li>
              </ol>
              <a
                download
                href="https://test.safexpay.ae/plugins/Prestashop.zip"
                class="btn btn-primary mb-20"
                //  target="_blank"
              >
                Download Plugin
              </a>

              {/* <div className="">

         
               <div class="divider"></div>
               <h2>os COMMERCE</h2>
               <div class="row">
                  <div class="col-md-4">
                     <div class="">
                        <div class="fl">
                           <img class="img-fluid img-width1" src="assets/images/pg-images/os_commerce.5c193ebc.png" />
                        </div>
                        <div class="fr lh-60">
                           <label><b>os COMMERCE</b></label>
                        </div>
                     </div>
                  </div>
               </div>
               <p className='mt-30'>
                  Allows you to use Safexpay payment gateway with the osCommerce shopping cart. This is the Safexpay payment gateway module is for osCommerce. Allows you to use Safexpay payment gateway with the osCommerce plugin. It uses the Safexpay payment url for payment so that you don't have to install an SSL certificate on your site.
               </p>
               <h5>Installation</h5>
               <ol>
                  <li>Ensure you have osCommerce v2.3.4 installed.</li>
                  <li>Unzip and upload contents of the includes to your /osCommerce install directory.</li>
                  <li>Login to your osCommerce admin & go to "Modules", then "Payment" & select Safexpay from the list and click on install.</li>
               </ol>
               <h5>Configuration</h5>
               <ol>
                  <li>Login to your Oscommerce admin & go to "Modules", then "Payment" & select Safexpay from the list and click on Edit.</li>
                  <li>Enter your Merchant id ,Merchant Key,Transaction Type and Url and save the configuration.</li>
               </ol>
               <a href="https://paygateindiapvt-my.sharepoint.com/personal/marketing_safexpay_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Fmarketing%5Fsafexpay%5Fcom%2FDocuments%2FDeveloper%20Doc%20Plugins%2FOscommerce%2FOSCommerce%2Ezip&parent=%2Fpersonal%2Fmarketing%5Fsafexpay%5Fcom%2FDocuments%2FDeveloper%20Doc%20Plugins%2FOscommerce&ga=1" class="btn btn-primary mb-20" target="_blank">Download Plugin</a>
               </div> */}

              {/* <div className="">

                
               <div class="divider"></div>

               <h2>WHMCS:</h2>
               <div class="row">
                  <div class="col-md-4">
                     <div class="">
                        <div class="fl">
                           <img class="img-fluid img-width1" src="assets/images/pg-images/download (4).png" />
                        </div>
                        <div class="fr lh-60">
                           <label><b>WHMCS</b></label>
                        </div>
                     </div>
                  </div>
               </div>
               <br/><br/>
               <a href="https://paygateindiapvt-my.sharepoint.com/personal/marketing_safexpay_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Fmarketing%5Fsafexpay%5Fcom%2FDocuments%2FDeveloper%20Doc%20Plugins%2FWhmcs%2Dchecksum%2Fmodules%2Ezip&parent=%2Fpersonal%2Fmarketing%5Fsafexpay%5Fcom%2FDocuments%2FDeveloper%20Doc%20Plugins%2FWhmcs%2Dchecksum&ga=1" class="btn btn-primary" target="_blank">Download Plugin</a>
               <p className='mt-10'><b>Note:</b> Please contact safexpay team for integration.</p>

               </div> */}

              {/* <div className="">

           
               <div class="divider"></div>
               <h2>Codeigniter</h2>
               <div class="row">
                  <div class="col-md-4">
                     <div class="">
                        <div class="fl">
                           <img class="img-fluid img-width1" src="assets/images/pg-images/download (5).png" />
                        </div>
                        <div class="fr lh-60">
                           <label><b>Codeigniter</b></label>
                        </div>
                     </div>
                  </div>
               </div>
               <ul>
                  <li><b>Step 1:</b> Download the ZIP FILE.</li>
                  <li><b>Step 2:</b> Extract the folder as per the provided dirctory into your project.</li>
                  <li><b>Step 3:</b> Goto app-{'>'}config-{'>'}PaygConfig.php -{'>'} to place the required Details provided from safexpay.</li>
                  <li><b>Step 4:</b> Goto app-{'>'}Controllers-{'>'}Transaction.php contains the working of the API.</li>
                  <li><b>Step 5:</b> Goto app-{'>'}Libraries-{'>'}Payg.php contains the Encryption logic.</li>
               </ul>
               <a href="https://paygateindiapvt-my.sharepoint.com/personal/marketing_safexpay_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Fmarketing%5Fsafexpay%5Fcom%2FDocuments%2FDeveloper%20Doc%20Plugins%2FCodeigniter%2FCodiegnator%204%20checksum%2Ezip&parent=%2Fpersonal%2Fmarketing%5Fsafexpay%5Fcom%2FDocuments%2FDeveloper%20Doc%20Plugins%2FCodeigniter&ga=1" class="btn btn-primary mb-20" target="_blank">Download Plugin</a>
               </div> */}

              {/* <div className="">
               <div class="divider"></div>
               <h2>Laravel</h2>
               <div class="row">
                  <div class="col-md-4">
                     <div class="">
                        <div class="fl">
                           <img class="img-fluid img-width1" src="assets/images/pg-images/download (6).png" />
                        </div>
                        <div class="fr lh-60">
                           <label><b>Laravel</b></label>
                        </div>
                     </div>
                  </div>
               </div>
               <ul>
                  <li><b>Step 1:</b> Download the ZIP file from the provided LINK.</li>
                  <li><b>Step 2:</b> REPLACE the file as per the folder provided in the plugin into your project directory.</li>
                  <li><b>Point 1:</b> UNDER resources-{'>'}view-{'>'}transaction folder three additional files are present which handle actual request initiated for the simulator.</li>
                  <li><b>Point 2:</b> UNDER App-{'>'}Libraries you will be getting a payg file which contains the AES logic that needed for the encrypt and decrypt process.</li>
                  <li><b>Point 3:</b> UNDER App-{'>'}HTTP-{'>'}Controllers you will find Transaction.php which contains actual logic for the payment gateway Request and response.</li>
                  <li><b>Point 4:</b> UNDER Config you will getting a PaygConfig file to fill out the MID KEY and URL which is used provided from safexpay side.</li>
               </ul>
               <a href="https://paygateindiapvt-my.sharepoint.com/personal/marketing_safexpay_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Fmarketing%5Fsafexpay%5Fcom%2FDocuments%2FDeveloper%20Doc%20Plugins%2FLaravel%2FLaravel%20V8%20Checksum%2Ezip&parent=%2Fpersonal%2Fmarketing%5Fsafexpay%5Fcom%2FDocuments%2FDeveloper%20Doc%20Plugins%2FLaravel&ga=1" class="btn btn-primary mb-20" target="_blank">Download Plugin</a>
               </div> */}

              <p className="mt-30">
                <u>AUTHORIZATIONS:</u>
              </p>
            </section>
          </div>
          <div class="col-md-4 extreme-rt-div">
            <div
              class="accordion accordion-alterate arrow-right mt-160 side-api"
              id="popularTopics"
            >
              <div class="card">
                <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                    <div
                      style={{
                        backgroundColor: "rgb(17 23 26)",
                        color: "#fff",
                      }}
                      onClick={onClickCangeTab}
                    >
                      <button> POST </button> /api/plugins{" "}
                      {TabCheck ? <FaAngleUp /> : <FaAngleDown />}
                    </div>
                  </h5>
                </div>
                {TabCheck && (
                  <div>
                    <br />
                    <div class="card-body">
                      <p class="mb-0">Production server (uses live data)</p>
                      <div class="api-div-bor">
                        <span>https://www.avantgardepayments.com/agcore</span>
                        <span class="col-org">/api/plugins</span>
                      </div>
                      <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                      <div class="api-div-bor">
                        <span>https://pguat.safexpay.com/agcore</span>
                        <span class="col-org">/api/plugins</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default RedirectCheckoutPlugins;
